import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { CustomFieldBuilder } from "../../containers/utilities/CustomFieldBuilder";
import { isMultiSelectField } from "../../constants/field-ui-type";

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    supportedFields?: any[];
    templateName: string
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, supportedFields = undefined, templateName }) => {
    const { translate } = useLocale();
    const formik = useFormikContext<any>();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);
    const detailFields = supportedFields?.filter(field => !isMultiSelectField(field.fieldTypeId)) || [];
    const multiSelectFields = supportedFields?.filter(filter => isMultiSelectField(filter.fieldTypeId)) || [];
    
    return <div className="flex flex-col h-full relative" style={{ height: "501px" }}>
        <div className="flex-1 overflow-y-auto pt-3 pr-3 mb-16">
            <div className="flex flex-col">
                <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.description)}:</span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.name)}: <span className="text-sm text-black">{formik.values.name}</span></span>
                <span className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.type)}: <span className="text-sm text-black">{templateName}</span></span>
                {detailFields && detailFields.length > 0
                    ? detailFields.reduce((formFields, field) => customFieldBuilder.buildSummaryField(formFields, field), new Array(0))
                        .map(fieldBundle => {
                            return fieldBundle.length === 1
                                ? fieldBundle[0].span
                                    ? fieldBundle[0].content
                                    : <>{fieldBundle[0].content}</>
                                : fieldBundle.map(field => field.content)
                        })
                    : <span>{translate.byKey(TranslationKeys.noContent)}</span>}
            </div>
            
            {/* Multi-select option */}
            {multiSelectFields && multiSelectFields.length > 0 && multiSelectFields.map((field) => {
                const fieldValue = formik.values.custom?.[field.systemName];
                const selectedNames = Array.isArray(fieldValue?.names) ? fieldValue.names : [];
                const hasSelectedValues = selectedNames.length > 0;

                return (hasSelectedValues && (<>
                    <hr />
                    <div className="flex flex-col pt-3" key={field.systemName}>
                        <span className="p-1 text-lg font-bold">{field.displayName}</span>
                        <span className="p-1 text-xs text-gray-600">
                            {
                                Object.keys(formik.values.custom).length > 0 && formik.values.custom[field.systemName]["names"] && Array.isArray(formik.values.custom[field.systemName]["names"]) ?
                                    formik.values.custom[field.systemName]["names"].join(", ") :
                                    formik.values.custom[field.systemName]
                            }
                        </span>
                    </div>
                    <hr />
                </>));
            })}

            {/* Triggered By */}
            {formik.values.triggeredByNames && formik.values.triggeredByNames.length > 0 && <>
                <hr />
                <div className="flex flex-col pt-3" key={"triggered-by"}>
                    <span className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.triggeredBy)}</span>
                    <span className="p-1 text-xs text-gray-600">{formik.values.triggeredByNames.join(", ")}</span>
                </div>
                <hr />
            </>}
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={e => { onBack && onBack(e) }}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={false ? 'button' : 'submit'}
                    onClick={onNext ? (e) => onNext(e) : () => { }}>{translate.byKey(TranslationKeys.assign)}</button>
            </div>
        </div>
    </div>;
};
